import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { commonActions, chempCertboxActions, modalActions, alertActions } from '../../../../../store/actions'

import ChempRcvList from './ChempRcvList'
import Calendar from '../../../../../module/component-box/Calendar'
import queryString from 'query-string'
import Pagination from '../../../../../module/pagination-box'
import history from '../../../../../route/history'
import Loading from '../../../../../module/loading/Loading'

const ChempRcvCertbox = (props) => {
  const [state, setState] = useState({})
  const [searchWord, setSearchWord] = useState('')
  const [tempFrom, setTempFrom] = useState('')
  const [tempTo, setTempTo] = useState('')
  const [searchInfo, setSearchInfo] = useState([])

  const [countInfo, setCountInfo] = useState({
    countALL: 0,
    count03: 0,
    count10: 0,
    count11: 0,
    count12: 0,
  })

  const [pagingInfo, setPagingInfo] = useState({})
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    props.common({ mainCd: ['CRT_STS_CD', 'CRT_DV', 'ISSU_INST_CD'] })
    const query = queryString.parse(history.location.search)
    const state = queryString.parse(history.location.state)

    selectDay('Y1')

    if (Object.keys(query).length > 0) {
      props.settingHistory(query)

      const tmpSearchInfo = [
        { type: 'tabStatus', value: query.tabStatus },
        { type: 'srhKind', value: query.srhKind },
        { type: 'srhPrchsNm', value: query.srhPrchsNm },
        { type: 'newSearchType', value: query.newSearchType },
        { type: 'searchWord', value: query.searchWord },
        { type: 'srhFrom', value: query.srhFrom },
        { type: 'srhTo', value: query.srhTo },
        { type: 'srhOrder', value: query.srhOrder },
        { type: 'srhBy', value: query.srhBy },
      ]
      console.log('tmpSearchInfo', tmpSearchInfo)

      setSearchInfo(tmpSearchInfo)
      searchList(tmpSearchInfo)
      if (query.searchWord) {
        setSearchWord(query.searchWord)
      }
    } else if (Object.keys(state).length > 0) {
      props.settingHistory(state)

      const tmpSearchInfo = [
        { type: 'tabStatus', value: state.tabStatus },
        { type: 'srhKind', value: state.srhKind },
        { type: 'srhPrchsNm', value: state.srhPrchsNm },
        { type: 'newSearchType', value: state.newSearchType },
        { type: 'searchWord', value: state.searchWord },
        { type: 'srhFrom', value: state.srhFrom },
        { type: 'srhTo', value: state.srhTo },
        { type: 'srhOrder', value: state.srhOrder },
        { type: 'srhBy', value: state.srhBy },
      ]
      console.log('tmpSearchInfo', tmpSearchInfo)

      setSearchInfo(tmpSearchInfo)
      searchList(tmpSearchInfo)
      if (state.searchWord) {
        setSearchWord(state.searchWord)
      }
    } else {
      searchList(searchInfo)
    }

    return () => {
      props.changeSearchInfo(null) // 이전 검색 초기화
    }
  }, [])

  useEffect(() => {
    // count갯수 설정...
    setCountInfo({
      ...countInfo,
      countALL: props.countInfo?.ALL,
      count03: props.countInfo?.['03'],
      count10: props.countInfo?.['10'],
      count11: props.countInfo?.['11'],
      count12: props.countInfo?.['12'],
    })
  }, [props.countInfo])

  // 검색조건 단건 변경시
  useEffect(() => {
    if (props.soloSelectInfo === null || props.soloSelectInfo === undefined) return
    let arr = searchInfo.filter((info) => info.type !== props.soloSelectInfo?.type)

    arr.push(props.soloSelectInfo)
    setSearchInfo(arr)
    searchList(arr)
  }, [props.soloSelectInfo])

  useEffect(() => {
    if (props.commoncode.length < 1) return
  }, [props.commoncode])

  // 수신함리스트
  useEffect(() => {
    const tRs = props.certboxList?.totalElements ? props.certboxList?.totalElements : 0
    const tPage = Math.ceil(tRs / 10)
    setPagingInfo({
      totalRecords: props.certboxList?.totalElements ? props.certboxList?.totalElements : 0,
      currentPage: state.pageIdx ? parseInt(state.pageIdx) + 1 : 1,
      pageNumber: props.certboxList?.pageable?.pageNumber,
      totalPage: tPage,
      pagesToShow: 10,
    })
    if (props.certboxList) {
      setLoading(false)
    }
  }, [props.certboxList])


  const searchTabInfo = [
    {
      title: '전체',
      id: '99',
      count: countInfo.countALL,
    },
    {
      // title: '제출',
      title: '발급완료',
      id: '03',
      count: countInfo.count03,
    },
    {
      // title: '제출',
      title: '수취준비',
      id: '10',
      count: countInfo.count10,
    },
    {
      title: '수취오류',
      id: '11',
      count: countInfo.count11,
    },
    {
      title: '수취완료',
      id: '12',
      count: countInfo.count12,
    },
  ]

  const onSelected = (e, type, value) => {
    console.log('#################################################### onSelected start')
    console.log('type', type)
    console.log('value', value)
    if (type === 'tabStatus') {
      return props.changeSearchInfo({ type, value })
      //setTabId(value)
    } else if (type === 'srhOrder') {
      if (searchInfo.find((s) => s.type === 'srhBy')?.value === 'desc') {
        setSearchInfo([
          { type: 'tabStatus', value: searchInfo.find((s) => s.type === 'tabStatus')?.value || '' },
          { type: 'srhKind', value: searchInfo.find((s) => s.type === 'srhKind')?.value || '' },
          { type: 'srhPrchsNm', value: searchInfo.find((s) => s.type === 'srhPrchsNm')?.value || '' },
          { type: 'newSearchType', value: searchInfo.find((s) => s.type === 'newSearchType')?.value || '' },
          { type: 'searchWord', value: searchInfo.find((s) => s.type === 'searchWord')?.value || '' },
          { type: 'srhFrom', value: searchInfo.find((s) => s.type === 'srhFrom')?.value || '' },
          { type: 'srhTo', value: searchInfo.find((s) => s.type === 'srhTo')?.value || '' },
          { type: 'srhOrder', value: value },
          { type: 'srhBy', value: 'asc' },
        ])
        return searchList(searchInfo)
      } else {
        setSearchInfo([
          { type: 'tabStatus', value: searchInfo.find((s) => s.type === 'tabStatus')?.value || '' },
          { type: 'srhKind', value: searchInfo.find((s) => s.type === 'srhKind')?.value || '' },
          { type: 'srhPrchsNm', value: searchInfo.find((s) => s.type === 'srhPrchsNm')?.value || '' },
          { type: 'newSearchType', value: searchInfo.find((s) => s.type === 'newSearchType')?.value || '' },
          { type: 'searchWord', value: searchInfo.find((s) => s.type === 'searchWord')?.value || '' },
          { type: 'srhFrom', value: searchInfo.find((s) => s.type === 'srhFrom')?.value || '' },
          { type: 'srhTo', value: searchInfo.find((s) => s.type === 'srhTo')?.value || '' },
          { type: 'srhOrder', value: value },
          { type: 'srhBy', value: 'desc' },
        ])
        return searchList(searchInfo)
      }
    } else if (type === 'srhPrchsNm') {
      return props.changeSearchInfo({ type, value })
    } else if (type === 'srhKind') {
      return props.changeSearchInfo({ type, value })
    } else if (type === 'newSearchType') {
      return props.changeSearchInfo({ type, value })
    } else if (type === 'srhFrom') {
      setSearchInfo([
        { type: 'tabStatus', value: searchInfo.find((s) => s.type === 'tabStatus')?.value || '' },
        { type: 'srhKind', value: searchInfo.find((s) => s.type === 'srhKind')?.value || '' },
        { type: 'srhPrchsNm', value: searchInfo.find((s) => s.type === 'srhPrchsNm')?.value || '' },
        { type: 'newSearchType', value: searchInfo.find((s) => s.type === 'newSearchType')?.value || '' },
        { type: 'searchWord', value: searchInfo.find((s) => s.type === 'searchWord')?.value || '' },
        { type: 'srhFrom', value: value },
        { type: 'srhTo', value: searchInfo.find((s) => s.type === 'srhTo')?.value || '' },
        { type: 'srhOrder', value: searchInfo.find((s) => s.type === 'srhOrder')?.value || '' },
        { type: 'srhBy', value: searchInfo.find((s) => s.type === 'srhBy')?.value || ''  },
      ])
      return setTempFrom(value)
    } else if (type === 'srhTo') {
      setSearchInfo([
        { type: 'tabStatus', value: searchInfo.find((s) => s.type === 'tabStatus')?.value || '' },
        { type: 'srhKind', value: searchInfo.find((s) => s.type === 'srhKind')?.value || '' },
        { type: 'srhPrchsNm', value: searchInfo.find((s) => s.type === 'srhPrchsNm')?.value || '' },
        { type: 'newSearchType', value: searchInfo.find((s) => s.type === 'newSearchType')?.value || '' },
        { type: 'searchWord', value: searchInfo.find((s) => s.type === 'searchWord')?.value || '' },
        { type: 'srhFrom', value: searchInfo.find((s) => s.type === 'srhFrom')?.value || '' },
        { type: 'srhTo', value: value },
        { type: 'srhOrder', value: searchInfo.find((s) => s.type === 'srhOrder')?.value || '' },
        { type: 'srhBy', value: searchInfo.find((s) => s.type === 'srhBy')?.value || ''  },
      ])
      return setTempTo(value)
    }

    if (type !== 'searchWord') {
      setSearchInfo(
        searchInfo.map((info) =>
          info.type === type
            ? {
                type,
                value: moment(value).format('Y-MM-DD'),
              }
            : info,
        ),
      )
    } else {
      if (
        (searchInfo.find((s) => s.type === 'srhFrom')?.value !== '' && searchInfo.find((s) => s.type === 'srhTo')?.value !== '') ||
        (searchInfo.find((s) => s.type === 'srhFrom')?.value !== 'undefined' &&
          searchInfo.find((s) => s.type === 'srhTo')?.value !== 'undefined')
      ) {
        if (searchInfo.find((s) => s.type === 'srhFrom')?.value > searchInfo.find((s) => s.type === 'srhTo')?.value) {
          return props.error({ message: '기간설정을 다시 입력해주세요.' })
        } else if (tempFrom > tempTo) {
          return props.error({ message: '기간설정을 다시 입력해주세요.' })
        } else {
          if (type === 'searchWord') {
            return props.changeSearchInfo({ type, value })
          } else {
            return searchList(searchInfo)
          }
        }
      } else {
        if (type === 'searchWord') {
          return props.changeSearchInfo({ type, value })
        } else {
          return searchList(searchInfo)
        }
      }
    }
    console.log('#################################################### onSelected end')
  }

  const searchList = (searchInfo, index = 0) => {
    /* 페이지 조회 시 최초 한번 실행 후 검색 버튼 클릭 시 실행 되는 함수 */
    if (searchInfo?.find((s) => s.type === 'srhFrom')?.value > searchInfo?.find((s) => s.type === 'srhTo')?.value) {
      return props.error({ message: '기간설정을 다시 입력해주세요.' })
    }

    let sendSearch = {}
    if (searchInfo === null) {
      // history 남아있을시
      sendSearch = {
        srhFrom: props.history?.srhFrom,
        srhTo: props.history?.srhTo,
        srhKind: props.history?.srhKind,
        tabStatus: props.history?.tabStatus ? props.history?.tabStatus : '99',
        srhOrder: props.history?.srhOrder ? props.history?.srhOrder : '',
        srhBy: props.history?.srhBy ? props.history?.srhBy : 'desc',
        newSearchType: props.history?.newSearchType ? props.history?.newSearchType : 'docid',
        searchWord: props.history?.searchWord ? props.history?.searchWord : '',
        srhPrchsNm: props.history?.srhPrchsNm ? props.history?.srhPrchsNm : '',
      }
    } else {
      sendSearch = {
        srhFrom: searchInfo.find((s) => s.type === 'srhFrom')?.value || '',
        srhTo: searchInfo.find((s) => s.type === 'srhTo')?.value || '',
        srhKind: searchInfo.find((s) => s.type === 'srhKind')?.value || '',
        tabStatus: searchInfo.find((s) => s.type === 'tabStatus')?.value || '',
        srhOrder: searchInfo.find((s) => s.type === 'srhOrder')?.value || '',
        srhBy: searchInfo.find((s) => s.type === 'srhBy')?.value || '',
        newSearchType: searchInfo.find((s) => s.type === 'newSearchType')?.value || 'docid',
        searchWord: searchInfo.find((s) => s.type === 'searchWord')?.value || '',
        srhPrchsNm: searchInfo.find((s) => s.type === 'srhPrchsNm')?.value || '',
      }
    }

    sendSearch.pageIdx = typeof index === 'object' ? 0 : index

    setState({
      ...state,
      ...sendSearch,
    })

    let paramStr = queryString.stringify(sendSearch)

    paramStr.length > 0 && (paramStr = '?' + paramStr)
    history.push('/service/certbox/chemp' + paramStr)

    setLoading(true)
    // 수신함 리스트 조회
    props.readCertboxList(sendSearch)
  }

  const handleKeyPress = (e) => {
    const { name, value } = e.target
    if (e.key === 'Enter') {
      onSelected(e, name, value)
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    onSelected(e, name, value)
  }

  const selectDay = (type) => {
    const d = new Date()
    const year = d.getFullYear() // 년
    const month = d.getMonth() // 월
    const day = d.getDate() // 일

    let tdt = new Date(year, month, day)
    tdt = moment(tdt).format('Y-MM-DD')
    if (type === 'W1') {
      // 1주일
      let fdt = new Date(year, month, day - 7)
      fdt = moment(fdt).format('Y-MM-DD')
      let arr = []
      arr.push({ type: 'srhFrom', value: fdt })
      arr.push({ type: 'srhTo', value: tdt })

      setTempFrom(fdt)
      setTempTo(tdt)
      setSearchInfo(arr)
      // searchList(arr)
    } else if (type === 'M1') {
      // 1개월
      let fdt = new Date(year, month - 1, day)
      fdt = moment(fdt).format('Y-MM-DD')
      let arr = []
      arr.push({ type: 'srhFrom', value: fdt })
      arr.push({ type: 'srhTo', value: tdt })

      setTempFrom(fdt)
      setTempTo(tdt)
      setSearchInfo(arr)
      // searchList(arr)
    } else if (type === 'M3') {
      // 3개월
      let fdt = new Date(year, month - 3, day)
      fdt = moment(fdt).format('Y-MM-DD')
      let arr = []
      arr.push({ type: 'srhFrom', value: fdt })
      arr.push({ type: 'srhTo', value: tdt })

      setTempFrom(fdt)
      setTempTo(tdt)
      setSearchInfo(arr)
      // searchList(arr)
    } else if (type === 'M6') {
      // 6개월
      let fdt = new Date(year, month - 6, day)
      fdt = moment(fdt).format('Y-MM-DD')
      let arr = []
      arr.push({ type: 'srhFrom', value: fdt })
      arr.push({ type: 'srhTo', value: tdt })

      setTempFrom(fdt)
      setTempTo(tdt)
      setSearchInfo(arr)
      // searchList(arr)
    } else if (type === 'Y1') {
      // 1년
      let fdt = new Date(year - 1, month, day)
      fdt = moment(fdt).format('Y-MM-DD')
      let arr = []
      arr.push({ type: 'srhFrom', value: fdt })
      arr.push({ type: 'srhTo', value: tdt })

      setTempFrom(fdt)
      setTempTo(tdt)
      setSearchInfo(arr)
      // searchList(arr)
    } else {
      let arr = []
      arr.push({ type: 'srhFrom', value: '' })
      arr.push({ type: 'srhTo', value: '' })

      setTempFrom(null)
      setTempTo(null)
      setSearchInfo(arr)
      // searchList(arr)
    }
  }

  const prePage = (e) => {
    e.preventDefault()
    history.goBack()
  }

  return (
    <>
      {/* contents */}
      {loading ? <Loading /> : null}
      <div id="contents">
        <div className="content-header">
          <a href="#" className="page-prev" onClick={prePage}>
            뒤로이동
          </a>
          {/* mobile */}
          <h2>받은문서</h2>
          <div className="breadcrumb">
            <span>Home</span>
            <span>전자문서지갑</span>
            <em>받은문서</em>
          </div>
        </div>

        <div className="search-box">
          <div className="row">
            <span className="tit">기간</span>
            <span className="datepicker">
              <Calendar
                onSelect={(value) => {
                  onSelected(null, 'srhFrom', value ? moment(value).format('Y-MM-DD') : '')
                }}
                default={tempFrom}
                title="처음날짜(발급일)"
              />
              <span className="split">~</span>
              <Calendar
                onSelect={(value) => {
                  onSelected(null, 'srhTo', value ? moment(value).format('Y-MM-DD') : '')
                }}
                default={tempTo}
                title="마지막날짜(발급일)"
              />
            </span>
            <span className="form-date">
              <button type="button" className="btn-primary" onClick={() => selectDay('W1')}>
                1주일
              </button>
              <button type="button" className="btn-primary" onClick={() => selectDay('M1')}>
                1개월
              </button>
              <button type="button" className="btn-primary" onClick={() => selectDay('M3')}>
                3개월
              </button>
              <button type="button" className="btn-primary" onClick={() => selectDay('M6')}>
                6개월
              </button>
              <button type="button" className="btn-primary" onClick={() => selectDay('Y1')}>
                1년간
              </button>
              <button type="button" className="btn-primary" onClick={() => selectDay('99')}>
                초기화
              </button>
            </span>
          </div>
          <div className="row">
            <span className="tit">발급처</span>
            <select
              className="form-category"
              title="발급처"
              name="srhPrchsNm"
              id="srhPrchsNm"
              value={searchInfo?.find((i) => i.type === 'srhPrchsNm')?.value || ''}
              onChange={handleChange}
            >
              <option value="" key={''}>
                전체
              </option>
              {props.commoncode?.ISSU_INST_CD?.map((item) => (
                <option
                  key={item.cdName}
                  value={item.cdName}
                  defaultValue={searchInfo?.find((i) => i.type === 'srhPrchsNm')?.value === item.cdName}
                >
                  {item.cdName}
                </option>
              ))}
            </select>
            <span className="tit">문서유형</span>
            <select
              className="form-category2"
              title="문서유형"
              name="srhKind"
              id="srhKind"
              value={searchInfo?.find((i) => i.type === 'srhKind')?.value || ''}
              onChange={handleChange}
            >
              <option value="" key={''}>
                전체
              </option>
              {props.commoncode?.CRT_DV?.map((item) => (
                <option key={item.cd} value={item.cd} defaultValue={searchInfo?.find((i) => i.type === 'srhKind')?.value === item.cd}>
                  {item.cdName}
                </option>
              ))}
            </select>
            <span className="tit">검색유형</span>
            <select
                className="form-category3"
                title="검색유형"
                name="newSearchType"
                id="newSearchType"
                value={searchInfo?.find((i) => i.type === 'newSearchType')?.value || 'docid'}
                onChange={handleChange}
            >
              {/*<option value="" key={''}>전체</option>*/}
              <option value="docid" key={'docid'} defaultValue={searchInfo?.find((i) => i.type === 'newSearchType')?.value === 'docid'} >발급번호</option>
            </select>
            <div className="inquiry-group">
              <input
                type="text"
                placeholder="발급번호 또는 시료명을 입력하세요."
                className="form-keyword"
                id="searchWord"
                name="searchWord"
                value={searchWord || ''}
                onChange={({ target }) => setSearchWord(target.value)}
                onKeyPress={handleKeyPress}
              />
              <button
                className="btn-search"
                onClick={(e) => {
                  onSelected(e, 'searchWord', searchWord)
                }}
              >
                검색
              </button>
            </div>
          </div>
        </div>

        <div className="tbl-wrap mt20 pc-only">
          <table className="tbl-list">
            <caption>전체, 발급완료, 수취준비, 수취오류, 수취완료 항목으로 구성</caption>
            <colgroup>
              <col style={{ width: '20%' }} />
              <col style={{ width: '20%' }} />
              <col style={{ width: '20%' }} />
              <col style={{ width: '20%' }} />
              <col style={{ width: '20%' }} />

            </colgroup>
            <thead>
              <tr>
                <th scope="col">전체</th>
                <th scope="col">발급완료</th>
                <th scope="col">수취준비</th>
                <th scope="col">수취오류</th>
                <th scope="col">수취완료</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                {searchTabInfo.map((item, index) => (
                  <td key={index}>
                    <a
                      href="./"
                      onClick={(e) => {
                        e.preventDefault()
                        onSelected(e, 'tabStatus', item.id)
                      }}
                      title={item.title}
                    >
                      {'11' === item.id ? (
                        <strong className="text-red"> {item.count}</strong>
                      ) : (
                        <strong className="text-blue"> {item.count}</strong>
                      )}
                    </a>
                  </td>
                ))}
              </tr>
            </tbody>
          </table>
        </div>

        <div className="tbl-wrap mobile-scroll2 mt40 mobile-only">
          <table className="tbl-list">
            <caption>전체, 발급완료, 수취준비, 수취오류, 수취완료 항목으로 구성</caption>
            <colgroup>
              <col style={{ width: '20%' }} />
              <col style={{ width: '20%' }} />
              <col style={{ width: '20%' }} />
              <col style={{ width: '20%' }} />
              <col style={{ width: '20%' }} />
            </colgroup>
            <thead>
              <tr>
                <th scope="col">전체</th>
                <th scope="col">발급완료</th>
                <th scope="col">수취준비</th>
                <th scope="col">수취오류</th>
                <th scope="col">수취완료</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                {searchTabInfo.map((item, index) => (
                  <td key={index}>
                    <a
                      href="./"
                      onClick={(e) => {
                        e.preventDefault()
                        onSelected(e, 'tabStatus', item.id)
                      }}
                      title={item.title}
                    >
                      {'11' === item.id ? (
                        <strong className="text-red"> {item.count}</strong>
                      ) : (
                        <strong className="text-blue"> {item.count}</strong>
                      )}
                    </a>
                  </td>
                ))}
              </tr>
            </tbody>
          </table>
        </div>

        <ChempRcvList
          data={props.certboxList?.content}
          orgdata={props.certboxOrgList}
          commoncode={props.commoncode}
          onSelected={onSelected}
          pagingInfo={pagingInfo}
          tabId={''}
        />

        <div className="list-footer">
          <Pagination pagingInfo={pagingInfo} onChange={(param) => searchList(searchInfo, param - 1)} />
        </div>

        <div className="guide-box gray mt40">
          <dl className="dlist1">
            <dt>처리상태 안내</dt>
            <dd>
              <span className="text-blue">발급완료</span> : 증명서 신청이 완료되어 발급이 가능합니다.
            </dd>
            <dd>
              <span className="text-red">안 읽음</span> : 구비서류 미제출 시 자동으로 취소됩니다.
            </dd>
            <dd>
              <span className="text-orange">반려</span> : 수취기관 반려한 문서.
            </dd>
            <dd>
              <span className="text-green">읽음</span> : 수취기관 읽음상태 해당문서는 반려할 수 없습니다.
            </dd>
          </dl>
        </div>
        <div className="guide-box gray mt20">
          <dl className="dlist1">
            <dt>수수료 취소 안내</dt>
            <dd>처리상태가 ‘접수’인 경우만 취소(환불) 가능이 가능합니다.</dd>
            <dd>
              결제 수단별 취소 기간 제한이 있으니 참고바랍니다.
              <br /> - 신용카드 / 무통장입금 : 결제 후 28일 이내 건에 대해서만 취소 가능
              <br /> - 휴대폰 : 결제 해당 월에 한하여 취소 가능
            </dd>
          </dl>
        </div>
      </div>
      {/* //contents */}
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    soloSelectInfo: state.chempCertbox?.selectInfo, // 수신함 검색조건
    certboxList: state.chempCertbox?.certboxList?.list,
    certboxOrgList: state.chempCertbox?.certboxList?.Alllist,
    countInfo: state.chempCertbox?.certboxList?.count,
    commoncode: state.commoncode?.co,
    history: state.chempCertbox?.history,
  }
}

const actionCreators = {
  changeSearchInfo: chempCertboxActions.changeSearchInfo, //수신함 검색조건 변경
  readCertboxList: chempCertboxActions.readCertboxList,    // 내문서함(받은문서함=수신함) 목록 조회
  settingHistory: chempCertboxActions.settingHistory,
  showModalBagic: modalActions.showModalBagic,
  common: commonActions.getCommonCode,
  error: alertActions.error,
}

export default connect(mapStateToProps, actionCreators)(ChempRcvCertbox)
